
import Tenx from "../../../assets/outline/Tenx.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TenxIcon({ className, dataTestid = "TenxIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Tenx data-testid={dataTestid} className={classes} {...rest} />
  );
}
